<template>
  <div class="stock-take" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="header" :style="{backgroundColor:isInStockTakeBox?'#ff3c00':'#fff'}">
      <div style="margin-top: 2vh">
        <img src="https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg" style="width: 12vh"
             v-if="isInStockTakeBox">
        <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg" style="width: 12vh" v-else>
      </div>
      <div>
        <img
          src="https://summit-img.geekpark.net/ifx/pc/%E5%B9%B4%E5%BA%A6%E5%A5%96%E9%A1%B9-%E7%99%BD%E8%89%B2-%E4%B8%AD%E6%96%87.svg"
          style="width: 8vh" v-if="isInStockTakeBox">
        <img
          src="https://summit-img.geekpark.net/ifx/pc/%E5%B9%B4%E5%BA%A6%E5%A5%96%E9%A1%B9-%E9%BB%91%E8%89%B2-%E4%B8%AD%E6%96%87.svg"
          style="width: 8vh" v-else>
      </div>
      <div style="margin-bottom: 2vh">
        <img
          src="https://summit-img.geekpark.net/06-%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-%E8%8B%B1%E6%96%87%E5%8F%8D%E7%99%BD.svg"
          style="width: 9.5vh;" v-if="isInStockTakeBox">
        <img src="https://summit-img.geekpark.net/06-%E5%B9%B4%E5%BA%A6%E7%9B%98%E7%82%B9-%E8%8B%B1%E6%96%87.svg"
             style="width: 9.5vh;" v-else>
      </div>
    </div>
    <div class="content">
      <div class="brief">
        <p>
          极客公园始终致力于以专业的判断力为大众找到最值得关注的科技力量。每届 IF，极客公园通过 5 大奖项评选，梳理过去一年中优秀的科技产品、创新的企业组织以及有影响力的企业家，将他们点亮。
        </p>
        <p>
          来 IF X 现场，为你更深度解读他们背后的不平凡之处。
        </p>
      </div>
      <div class="awards">
        <div style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-01.png') 0 0 /cover">
          <div>
            <a href="http://ifxawards.geekpark.net/innoawards" target="_blank">查看获奖名单 ></a>
          </div>
        </div>
        <div style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-02.png') 0 0 /cover">
          <div>
            <a href="http://ifxawards.geekpark.net/geekchoice" target="_blank">查看获奖名单 ></a>
          </div>
        </div>
        <div style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-03.png') 0 0 /cover">
          <div>
            <a href="http://ifxawards.geekpark.net/geeks100" target="_blank">查看获奖名单 ></a>
          </div>
        </div>
        <div style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-04.png') 0 0 /cover">
          <div>
            <a href="http://ifxawards.geekpark.net/cool30" target="_blank">查看获奖名单 ></a>
          </div>
        </div>
        <div style="background: url('https://summit-img.geekpark.net/%E5%A5%96%E9%A1%B9-05.png') 0 0 /cover">
          <div>
            <a href="http://ifxawards.geekpark.net/employer" target="_blank">查看获奖名单 ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockTake',
  data () {
    return {
      isInStockTakeBox: false
    }
  },
  methods: {
    mouseEnter () {
      this.isInStockTakeBox = true
    },
    mouseLeave () {
      this.isInStockTakeBox = false
    }
  }
}
</script>

<style scoped lang="less">
  .stock-take {
    display: flex;
    height: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 18vh;
    margin: 5vh 0;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    transition: background-color .3s;
  }

  .content {
    display: flex;
    margin: 3vh 0;
  }

  .brief {
    display: flex;
    width: 40vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.6;
    text-align: justify;
    font-size: 2.5vh;
    font-weight: 100;

    p {
      width: 25vh;

      &:last-of-type {
        margin-top: 1em;
      }
    }
  }

  .awards {
    display: flex;
    justify-content: space-between;
    width: 139vh;
    height: 100%;

    > div {
      position: relative;
      width: 26vh;
      height: 100%;
      border: 1px solid #f0f0f0;
      background-color: #d8d8d8;

      &:hover {
        > div {
          visibility: visible;
          opacity: 1;
        }
      }

      > div {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, .5);
        visibility: hidden;
        opacity: 0;
        transition: opacity .3s;

        a {
          text-decoration: none;
          margin-top: 25vh;
          padding-bottom: 1px;
          border-bottom: 1px solid #FF3C00;
          color: #FF3C00;
          font-size: 2.2vh;
          font-weight: bold;
        }
      }
    }
  }
</style>
